/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./ini.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./ini.component";
var styles_IniComponent = [i0.styles];
var RenderType_IniComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_IniComponent, data: {} });
export { RenderType_IniComponent as RenderType_IniComponent };
export function View_IniComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" ini works!\n"]))], null, null); }
export function View_IniComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-ini", [], null, null, null, View_IniComponent_0, RenderType_IniComponent)), i1.ɵdid(1, 114688, null, 0, i2.IniComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var IniComponentNgFactory = i1.ɵccf("app-ini", i2.IniComponent, View_IniComponent_Host_0, {}, {}, []);
export { IniComponentNgFactory as IniComponentNgFactory };
